import React from "react"
import { Link } from 'gatsby'
import PropTypes from "prop-types"

const CallToAction = ({ className, link, children }) => {
  return (
    <Link
      to={link}
      className={`${className} inline-block py-2 self-end md:self-start md:py-3 px-3 md:px-6 mt-4 transition-medium`}
    >
      {children}
    </Link>
  )
}

CallToAction.propTypes = {
  link: PropTypes.string.isRequired,
}

CallToAction.defaultProps = {
  className: 'border border-indigo-700 hover:border-blue-500 hover:bg-blue-500 text-indigo-700 hover:text-white',
}

export default CallToAction
